import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Mobile, Centered } from "@miro-site/core";
import React, { useEffect, useState } from "react";
var StickyUseTemplateMobile = function(param) {
    var showOnRefIntersection = param.showOnRefIntersection, templateActions = param.templateActions, actionButtonProps = param.actionButtonProps, metadataId = param.metadataId;
    var ref = useState(false), showStickyButton = ref[0], setShowStickyButton = ref[1];
    useEffect(function() {
        var isIntersectionObserverSupported = "IntersectionObserver" in window && "IntersectionObserverEntry" in window;
        if (isIntersectionObserverSupported && (showOnRefIntersection === null || showOnRefIntersection === void 0 ? void 0 : showOnRefIntersection.current)) {
            var element = showOnRefIntersection.current;
            var observer = new IntersectionObserver(function(param) {
                var _param = _sliced_to_array(param, 1), entry = _param[0];
                setShowStickyButton(!entry.isIntersecting);
            }, {
                rootMargin: "200px 0px 0px 0px"
            });
            observer.observe(element);
            return function() {
                observer.unobserve(element);
            };
        }
    }, []);
    if (!showStickyButton) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Mobile, {
        "data-track-place": "sticky-use-template",
        children: /*#__PURE__*/ _jsx(Centered, {
            $styles: {
                position: "fixed",
                zIndex: 700,
                bottom: 24,
                left: "50%",
                transform: "translateX(-50%)"
            },
            children: actionButtonProps ? /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                "data-track-id": "use-template",
                "data-template-id": metadataId,
                $buttonType: "primary",
                $size: "medium",
                $withArrow: true
            }, actionButtonProps), {
                children: actionButtonProps.children || templateActions.USE_TEMPLATE
            })) : null
        })
    });
};
export default StickyUseTemplateMobile;
